<h2>Written Word Media Credits</h2>
<div class="father-circle">
    <div class="circular-progress">
        <div class="numbers">
            <div class="top"><span>${{total}}</span></div>
            <div class="middle">
                <span class="left">${{fraction * 3}}</span>
                <span class="right">${{fraction}}</span>
            </div>
            <div class="bottom"><span>${{fraction * 2}}</span></div>
        </div>
        <div class="text">
            <span class="value-container">0%</span>
            <span class="available-credits">available <br> credit</span>
        </div>
    </div>
</div>
<div class="footer-credits">
    <p class="used"><span class="circle-grey"></span> {{available | currency: 'USD'}} Available credit</p>
    <p class=" available"><span class="circle-green"></span> {{currentLimit  | currency: 'USD'}} Used credit</p>
</div>
